import React from 'react'
import { useParams } from 'react-router-dom'
import { useFetch } from 'use-http'

import { Box, Heading, Stack, Text } from '@myxplor/stardust'

import LoadingLoop from '~/src/components/LoadingLoop'

import { AccountDetail } from './types'
import ApiKeyList from './ApiKeyList'
import ServiceList from './ServiceList'

const AccountView = () => {
  const { accountId } = useParams()

  const accountRequest = useFetch(`/api/v1/accounts/${accountId}`, {}, [])

  if (accountRequest.loading) {
    return <LoadingLoop />
  }

  if (accountRequest.error) {
    return <div>Error...</div>
  }

  const account = accountRequest.data.data as AccountDetail

  return (
    <Stack space="small">
      <Box alignItems="center" display="flex" justifyContent="space-between" width={1}>
        <Heading level={4}>{account.name}</Heading>
      </Box>
      <Box display="flex">
        <Box display="flex" flexDirection="column" paddingRight="large">
          <Text prefab="overline" weight="bold">
            BMS
          </Text>
          <Text lineHeight={1.4} prefab="body">
            {account.vendor.name}
          </Text>
        </Box>
        {account.tenant_id && (
          <Box display="flex" flexDirection="column" paddingRight="large">
            <Text prefab="overline" weight="bold">
              Tenant
            </Text>
            <Text lineHeight={1.4} prefab="body">
              {account.tenant_id}
            </Text>
          </Box>
        )}
        <Box display="flex" flexDirection="column">
          <Text prefab="overline" weight="bold">
            Username
          </Text>
          <Text lineHeight={1.4} prefab="body">
            {account.username}
          </Text>
        </Box>
      </Box>
      <ApiKeyList account={account} />
      <ServiceList account={account} />
    </Stack>
  )
}

export default React.memo(AccountView)
